import { map, groupBy, flattenDeep, uniq } from 'lodash'

export const getEmailAddresses = (emails, lead, member) => {
    let to = map(Object.getOwnPropertyNames(groupBy(emails, 'to')), (address) => (address !== 'null') ? address.toLowerCase().split(',') : '')
    let cc = map(Object.getOwnPropertyNames(groupBy(emails, 'cc')), (address) => (address !== 'null') ? address.toLowerCase().split(',') : '')
    let bcc = map(Object.getOwnPropertyNames(groupBy(emails, 'bcc')), (address) => (address !== 'null') ? address.toLowerCase().split(',') : '')
    let allAddresses = flattenDeep([to, cc, bcc])

    let addresses = []
    for (let address of uniq(allAddresses))
        if (address !== lead.email && address !== member.email && address !== '')
            addresses.push({ 'id': address, 'name': address })

    return addresses
}



// WEBPACK FOOTER //
// ./src/utils/helpers/emails.js